import { useWebStoreContext } from "contexts";
import { useAppSelector } from "hooks";
import { PBV3RewardClaimStatus, PopUpVariant } from "interfaces";
import { selectPoisBountyV3State } from "redux/slices";
import { getTimeLeft } from "utils/time";

type EventReport = {
	name: string;
	opts: { [key: string]: string | number | undefined | null };
};

export const useReportEventOnClose = (
	variant: PopUpVariant | undefined
): EventReport | undefined => {
	const { nowTime } = useWebStoreContext();
	const {
		tracker: pb3Tracker,
		trackers: pb3Trackers,
		rewards: pb3Rewards
	} = useAppSelector(selectPoisBountyV3State);
	const eventReport = {} as EventReport;

	if (typeof variant === "undefined") {
		return;
	}

	switch (variant) {
		case "pb-reward-collected-v3":
			const timeLeft = getTimeLeft(nowTime, pb3Tracker?.endTime, "seconds");
			const timeTotal =
				getTimeLeft(pb3Tracker?.startTime, pb3Tracker?.endTime, "seconds") ||
				undefined;
			eventReport.name = "tp.web_frontend";
			eventReport.opts = {
				event_name: "reward_claimed_popup_closed",
				event_type: "pois_bounty_v3",
				action: "reward_claimed_popup_closed",
				source: "pois_bounty_menu",
				type:
					pb3Trackers?.eventType === "user"
						? "personal"
						: pb3Trackers?.eventType,
				time_left: timeLeft,
				time_total: timeTotal,
				event_id: pb3Trackers?.eventId,
				reward_id: pb3Rewards.findLast(
					(r: PBV3RewardClaimStatus) => r.isClaimed === true
				)?.reward?.rewardId
			};
			break;
		default:
			console.warn(`${variant} not handled`);
			return;
	}

	return eventReport;
};
